import React, { useState } from "react";
import PropTypes from "prop-types";
import { AlertTriangle, Textarea } from "@opendate-app/setlist";
import { formatPrice } from "../../../shared/teamCurrencyFormatting";
import DecisionModal from "../../ClassesShared/DecisionModal";
import { useRegistrationPageContext } from "./RegistrationPageContext";

function cancelWarning(registration, currencyCode) {
  if (registration.refundable) {
    return `Canceling refunds ${formatPrice(Number(registration.refundable_amount), currencyCode)} to the original payment method. The spot opens once the refund processes.`;
  }
  return "Canceling frees this attendee's spot. There is nothing to refund.";
}

export default function CancelRegistrationModal({ onClose }) {
  const { registration, currencyCode, cancelRegistration } = useRegistrationPageContext();
  const [reason, setReason] = useState("");
  const [working, setWorking] = useState(false);

  const confirm = async () => {
    setWorking(true);
    await cancelRegistration(reason);
    onClose();
  };

  return (
    <DecisionModal
      type="error"
      icon={AlertTriangle}
      title={`Cancel ${registration.full_name}'s registration?`}
      description={cancelWarning(registration, currencyCode)}
      cancelLabel="Keep Registration"
      confirmLabel={working ? "Canceling…" : registration.refundable ? "Cancel & Refund" : "Cancel Registration"}
      onClose={onClose}
      onConfirm={confirm}
      working={working}
    >
      <Textarea label="Reason (internal)" rows={3} maxLength={2000} value={reason} onChange={(e) => setReason(e.target.value)} />
    </DecisionModal>
  );
}

CancelRegistrationModal.propTypes = { onClose: PropTypes.func.isRequired };
